import React from 'react';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Checkbox, IconButton, Tooltip, Typography } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { useLanguageSettings } from 'views/Settings';

const useStyles = makeStyles(theme => ({
  button: {
    margin: '8px'
  },
  selected: {
    color: theme.palette.primary.main,
    margin: '8px'
  }
}));

export default function FilterButton(props) {
  const classes = useStyles();
  const {
    options,
    onChange,
    customButtonStyle,
    customPopperStyle,
    popperPlacement
  } = props;

  const [filterOptions, setFilterOptions] = React.useState(options || []);
  const [isSelected, setIsSelected] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { languageContent, getLanguageContent } = useLanguageSettings();
  const [componentContent, setComponentContent] = React.useState(null);

  React.useEffect(() => {
    if (languageContent) {
      setComponentContent(getLanguageContent("components", "filterButton"));
    }
  }, [languageContent]);

  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    setFilterOptions(options);
    setIsSelected(options.filter(i => i.checked).length > 0);
  }, [options]);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleChange = option => {
    let newOptions = options;
    newOptions = newOptions.map(item => {
      if (item.value === option.value) {
        item.checked = !item.checked;
      }
      return item;
    });
    setIsSelected(newOptions.filter(i => i.checked).length > 0);
    setFilterOptions(newOptions);
    if (onChange && typeof onChange === 'function') {
      onChange(newOptions);
    }
  };

  return (
    <>
      <Tooltip title={componentContent?.filterButtonTooltip || `Filter`}>
        <IconButton
          {...(customButtonStyle && { style: customButtonStyle })}
          className={isSelected ? classes.selected : classes.button}
          aria-label="filter list"
          ref={anchorRef}
          onClick={handleToggle}>
          <FilterListIcon />
        </IconButton>
      </Tooltip>
      <Popper
        open={open}
        {...(customPopperStyle && { style: customPopperStyle })}
        anchorEl={anchorRef.current}
        role={undefined}
        {...(popperPlacement && { placement: popperPlacement })}
        transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {filterOptions.map((option, index) => (
                    <MenuItem key={index} onClick={() => handleChange(option)}>
                      <Checkbox
                        checked={option.checked}
                        color="primary"
                        value="true"
                      />
                      <Typography variant="inherit">{option.value}</Typography>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
